<template>
    <nav class="primary-nav" :style="{ backgroundColor: siteColour }">
    <ol>
      <NavLink
        v-for="(l, index) in links"
        v-bind:key="index"
        :href="l.href"
        v-bind:observe="l.observe"
        :text="l.text"
      />
    </ol>
  </nav>
</template>

<script>
  import NavLink from "@/components/NavLink.vue";

  export default {
    name: 'PrimaryNav',
    components: {
      NavLink
    },
    props: {
      links: Array,
      siteColour: String,
    }
  }
</script>

<style lang="scss" scoped>
  .primary-nav {

    ol {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      list-style: none;
      height: 2em;
      margin: 0;
      padding: 0 1em 0 0;
      border-radius: 0 0 0 5px;
    }
  }

</style>
